
import axios from '@/axios'
import { notification } from 'ant-design-vue';

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // async SubmitUser({commit}, payload) {
  //
  //       try {
  //
  //           commit('LOADING', true);
  //
  //           await axios({
  //               method: 'post',
  //               url: 'admin/user',
  //               data: {data:payload}
  //           })
  //
  //           commit('INIT', payload);
  //
  //           setTimeout(()=>{
  //               notification.success({
  //                   message:"پیغام موفقیت آمیز",
  //                   description:"دسته شما با موفقیت ثبت شد."
  //               })
  //           },500)
  //
  //       } catch (e) {
  //           console.log('error has')
  //           commit('ERROR', e);
  //       } finally {
  //           commit('LOADING', false);
  //       }
  //
  //   },




  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  updateUserRole ({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch('updateUserInfo', {userRole: payload.userRole})
  }
}

export default actions
